// extracted by mini-css-extract-plugin
export default {"search-input":"marketplace-search-field-module__search-input--sJWPW"};